export const paymentTransactionSettingConstants = {
  CREATE_REQUEST: "PAYMENT_TRANSACTION_SETTING_CREATE_REQUEST",
  CREATE_SUCCESS: "PAYMENT_TRANSACTION_SETTING_CREATE_SUCCESS",
  CREATE_FAILURE: "PAYMENT_TRANSACTION_SETTING_CREATE_FAILURE",

  UPDATE_REQUEST: "PAYMENT_TRANSACTION_SETTING_UPDATE_REQUEST",
  UPDATE_SUCCESS: "PAYMENT_TRANSACTION_SETTING_UPDATE_SUCCESS",
  UPDATE_FAILURE: "PAYMENT_TRANSACTION_SETTING_UPDATE_FAILURE",

  GETALL_REQUEST: "PAYMENT_TRANSACTION_SETTING_GETALL_REQUEST",
  GETALL_SUCCESS: "PAYMENT_TRANSACTION_SETTING_GETALL_SUCCESS",
  GETALL_FAILURE: "PAYMENT_TRANSACTION_SETTING_GETALL_FAILURE",

  DELETE_REQUEST: "PAYMENT_TRANSACTION_SETTING_DELETE_REQUEST",
  DELETE_SUCCESS: "PAYMENT_TRANSACTION_SETTING_DELETE_SUCCESS",
  DELETE_FAILURE: "PAYMENT_TRANSACTION_SETTING_DELETE_FAILURE",

  DIALOG_REQUEST: "PAYMENT_TRANSACTION_SETTING_DIALOG_REQUEST",
  LOADING_REQUEST: "PAYMENT_TRANSACTION_SETTING_LOADING_REQUEST",
};
